import axios from "axios";
import config from "../../config";
const baseUrl = config.baseUrl;
const endpoint = "/api/financiero/informe-unoauno";

const getInformeUnoaUno = async () => {
  const response = await axios.get(`${baseUrl}${endpoint}`);
  return response.data;
};

export {
  getInformeUnoaUno
};